import { createContext, useContext } from "react";
import { ChatSession, Message } from "../interfaces/Chat";

interface ChatSessionsContextType {
  chatSessions: ChatSession[];
  updateSelectedChatSession: (chatSessionId: string) => void;
  addNewChatSession: (question?: string) => string;
  updateNewChatSession: (question: string) => void;
  updateChatSessionTitle: (chatId: string, newTitle: string) => void;
  resetSelectedChatSession: () => void;
  beginChatStream: () => { generation: number };
  invalidateActiveStream: () => void;
  isStreamGenerationActive: (generation: number) => boolean;
  setChatSessions: any;
  selectedChatSession: string | null | undefined;
  messages: Message[];
  setMessages: any;
  noMsgReset: React.MutableRefObject<boolean>;
  filterFromYear: number | null;
  setFilterFromYear: (year: number | null) => void;
  filterToYear: number | null;
  setFilterToYear: (year: number | null) => void;
  filterDocumentTypes: string[];
  setFilterDocumentTypes: (types: string[]) => void;
  filterAuthor: string | null;
  setFilterAuthor: (author: string | null) => void;
  mobileOpen: boolean;
  handleDrawerToggle: () => void;
  handleDrawerTransitionEnd: () => void;
  handleDrawerClose: () => void;
  inputRef: React.MutableRefObject<HTMLInputElement | null>;
}

const ChatSessionsContext = createContext<ChatSessionsContextType | undefined>(
  undefined
);

export function useChatSessionsContext() {
  const context = useContext(ChatSessionsContext);
  if (context === undefined) {
    throw new Error();
  }
  return context;
}

export default ChatSessionsContext;
